<!--
 * @Author: cmchiu
 * @Date: 2023-04-07 12:00:50
 * @LastEditTime: 2023-04-27 11:15:19
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\FileList.vue
 * 
-->
<template>
    <div class="item-file-list">
        item type: files{{ $route.query.id }}
        <ul>
            <li v-for="file in fileLs" :key="file.sno">
                <a :href="file.ItemFiles[0].location" target="_blank" v-text="file.ItemTitle"></a>
                <div style="width: 200px; text-align: right; float: right">{{ file.UpdDate }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getItemContent } from '@/api/common'

export default {
    name: 'itemFileList',

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: this.$route.query.id,
            fileLs: [],
        }
    },

    created() {
        this.getMenuItemLs()
    },

    methods: {
        async getMenuItemLs(chgFilters) {
            const vm = this
            vm.configs.loading = true
            if (chgFilters) vm.menuItem.pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                MenuID: vm.MenuID,
                // ItemStatus: vm.menuItem.filter.status,
                // Keyword: vm.menuItem.filter.keyword,
                // PageSize: vm.menuItem.pages.pageSize,
                // PageCurrent: vm.menuItem.pages.pageCurrent,
            }
            await getItemContent(params)
                .then(res => {
                    // handle success
                    vm.fileLs = [] //res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        // item.ItemImages = JSON.parse(item.ItemImages)
                        item.ItemFiles = JSON.parse(item.ItemFiles)
                        vm.fileLs.push(item)
                    })
                    // let pages = vm.menuItem.pages
                    // pages.totalResult = res.TotalResult
                    // if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                    //     pages.pageCurrent = 1
                    // }
                })
                .catch(err => {
                    // handle error
                    vm.fileLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },
    },
}
</script>

<style scoped lang="scss"></style>
